import React from "react";
import Icon from "../media/icon/icons";

const FooterModal = ({ isOpen, onClose, title, content }) => {
	if (!isOpen) return null;
 
	return (
		<div className="footer-modal-overlay">
			<div className="footer-modal">
				<div className="footer-modal-header">
					<h2>{title}</h2>
					<span className="footer-modal-close" onClick={onClose}><Icon name="close_fill" width={20} height={20} color="#00264c"></Icon></span>
				</div>
				<div className="footer-modal-body">
					<pre className="privacy-text">{content}</pre>
				</div>
				<div className="footer-modal-footer">
					<button onClick={onClose} className="modal-btn accept">Accept</button>
					<button onClick={onClose} className="modal-btn decline">Decline</button>
				</div>
			</div>
		</div>
	);
};

export default FooterModal;
